import { redirect } from 'react-router-dom';

const checkLogined = async () => {
    const access_token = localStorage.getItem('access_token');
    if (access_token) return redirect('/');
    return null;
};

export default checkLogined;
